var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _g2, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg3Wallet = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.023 89.007c0 1.28 2.155 2.94 6.93 2.94 5.827 0 11.245-2.486 17.19-2.486s9.246 2.486 16.005 2.486c5.44 0 17.666-2.737 17.666-4.267 0-1.369-8.17-2.175-10.208-2.175-6.323 0-9.03 2.435-14.761 2.435-5.077 0-15.166-2.059-21.615-1.773-4.318.19-11.207.458-11.207 2.84",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m43.172 32.674-18.691.575 9.812 48.292 18.69-.574z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "m24.47 33.256 11.697-.486.23 1.332-11.697.487"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m24.47 33.256 11.697-.486.23 1.332-11.697.487"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#97C7F6",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m39.962 34.135-.049-.312.4-.007.05.311z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F6780",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m40.363 34.128-.049-.312.176-.106.05.313z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m44.91 33.17-1.512.904-3.437.061.402-.007.176-.105z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m40.54 34.023-.05-.313 4.371-.852.05.312z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F6780",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m37.328 34.183-.05-.312.176-.105.05.312z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m41.875 33.226-1.336.797-.176.105-.401.008-3.035.054.4-.007.176-.105z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#97C7F6",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m36.927 34.19-.05-.313.401-.007.05.312z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m37.503 34.077-.049-.311 4.372-.853.049.312z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m38.84 33.28-1.337.797-.176.105-.4.007-3.036.055.4-.007.177-.105z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#97C7F6",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m33.891 34.246-.05-.313.402-.007.05.312z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F6780",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m34.292 34.238-.05-.313.177-.105.05.312z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m34.468 34.131-.05-.312 4.372-.852.05.312z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#97C7F6",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m30.855 34.3-.048-.313.4-.007.05.312z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F6780",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m31.257 34.293-.05-.313.177-.105.05.312z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m35.804 33.334-1.336.798-.176.105-.401.007-3.035.055.4-.007.177-.106z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m31.433 34.187-.05-.312 4.372-.852.049.311z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#97C7F6",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m27.82 34.354-.049-.313.4-.007.05.313z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F6780",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m28.221 34.346-.05-.312.177-.105.049.312z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m32.768 33.389-1.335.798-.176.105-.402.007-3.034.055.4-.007.176-.106z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m28.397 34.24-.049-.311 4.371-.853.05.312z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m29.733 33.443-1.337.798-.175.106-.4.007-3.037.054z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m24.785 34.409-.05-.312 4.95-.965.048.312z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#779CC1",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.419,
    d: "m47.849 35.746-3.586 3.585-1.099-5.169z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    d: "m47.849 35.746-3.586 3.585-1.099-5.169z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m47.849 35.746-3.586 3.585-1.099-5.169z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m47.85 35.746.363-.014-3.587 3.586-.363.014z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#6989AA",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m43.164 34.162.364-.014 4.684 1.584-.363.014z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#779CC1",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m48.96 40.971-3.586 3.587-1.099-5.17z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#56718B",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m48.96 40.971.363-.014-3.586 3.587-.364.014z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#6989AA",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m44.275 39.389.363-.014 4.685 1.582-.363.014z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#779CC1",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m50.07 46.2-3.585 3.584-1.098-5.168z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#56718B",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m50.07 46.2.364-.014-3.586 3.586-.363.014z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#6989AA",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m45.387 44.617.363-.014 4.684 1.583-.363.014z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#779CC1",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m51.182 51.425-3.586 3.586-1.099-5.17z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#56718B",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m51.182 51.425.363-.014-3.586 3.585-.363.014z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#6989AA",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m46.497 49.842.364-.014 4.684 1.584-.363.014z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#779CC1",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m52.293 56.652-3.586 3.586-1.099-5.169z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#56718B",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m52.292 56.652.364-.014-3.586 3.586-.364.015z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#6989AA",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m47.608 55.07.363-.014 4.685 1.582-.363.014z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#779CC1",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m53.403 61.877-3.585 3.587-1.099-5.169z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#56718B",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m53.403 61.878.364-.014-3.586 3.587-.364.014z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#6989AA",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m48.72 60.295.362-.014 4.685 1.583-.364.014z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#779CC1",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m54.515 67.105-3.587 3.585-1.098-5.168z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#56718B",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m54.515 67.106.363-.014-3.586 3.585-.364.014z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#6989AA",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m49.83 65.522.363-.014 4.685 1.583-.363.014z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#779CC1",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m55.625 72.332-3.585 3.587-1.1-5.171z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#56718B",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m55.625 72.332.364-.014-3.586 3.587-.363.014z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#6989AA",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m50.94 70.748.364-.014 4.685 1.584-.364.014z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#779CC1",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m56.736 77.558-3.585 3.587-1.1-5.17z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#56718B",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m56.736 77.559.363-.014-3.586 3.587-.363.013z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#6989AA",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m52.052 75.976.363-.014 4.684 1.582-.363.014z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "3-wallet_svg__a",
    width: 10,
    height: 50,
    x: 42,
    y: 38,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m48.316 38.506 3.086 48.698c-.783-.065-8.615.01-8.992-.032"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#3-wallet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8B8F56",
    d: "m47.274 86.482-4.136-48.05c.643.064 4.425.011 5.178.073l4.402 48.436c-.752-.062-5.082 1.675-5.726 1.611"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m47.274 86.482-4.136-48.05c.643.064 4.425.011 5.178.073l4.402 48.436c-.752-.062-5.082 1.675-5.726 1.611"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m48.316 38.506 3.086 48.698c-.783-.065-8.615.011-8.992-.032"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F834F",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M54.585 82.494h-2.98l-3.35-44.289 3.045.832z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D9157",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M58.21 82.495h-3.625L51.3 39.038l3.664.52z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m57.374 40.553-2.409-.997-3.664-.518-3.045-.832c-.782-.064-5.128-.42-5.505-.464l.672-.176c.273.03 3.446.294 5.511.463l.073.006 3.082.842 3.705.525 2.47 1.021z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE489",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M61.442 82.495h-.899l-3.17-41.943.89-.13z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C804D",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M60.544 82.495H58.21l-3.247-42.937 2.41.994z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m42.71 37.793.214 5.051 5.58-1.102-.248-3.535z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#8AB5E0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m67.824 33.136-.037.313-3.718.091.037-.314zM64.024 33.228l-.038.313-3.715.09.036-.313zM60.225 33.32l-.037.314-3.717.09.036-.313zM56.425 33.412l-.037.314-3.717.09.038-.313zM52.624 33.506l-.036.314-3.717.09.036-.314z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    d: "M34.095 33.01c-1.48 1.326.48 5.325 4.043 9.092s7.643 5.266 8.845 4.194c1.682-1.5-.252-5.122-3.728-8.705-3.999-4.122-7.663-5.922-9.16-4.581"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5E7A7",
    d: "M34.095 33.01c-1.48 1.326.48 5.325 4.043 9.092s7.643 5.266 8.845 4.194c1.682-1.5-.252-5.122-3.728-8.705-3.999-4.122-7.663-5.922-9.16-4.581"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M34.095 33.01c-1.48 1.326.48 5.325 4.043 9.092s7.643 5.266 8.845 4.194c1.682-1.5-.252-5.122-3.728-8.705-3.999-4.122-7.663-5.922-9.16-4.581"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M34.115 33.033c-.361.323-.515.811-.484 1.426.03.615.247 1.353.621 2.17.749 1.632 2.127 3.571 3.908 5.453 1.779 1.88 3.686 3.195 5.297 3.905.806.354 1.537.558 2.14.606.603.049 1.073-.06 1.365-.319.824-.735.77-1.997.063-3.536-.705-1.537-2.055-3.335-3.792-5.125-1.998-2.06-3.911-3.538-5.51-4.333-.8-.398-1.519-.625-2.13-.669-.61-.044-1.112.094-1.478.422z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#054280",
    d: "M35.595 33.565c-1.05.874.857 4.013 3.852 7.18s6.307 4.778 7.11 4.017c.946-.895-.573-3.925-3.568-7.091-2.671-2.824-6.387-4.942-7.394-4.106"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M35.508 33.735c-.966.795.967 3.866 3.935 7.004s6.179 4.803 6.915 4.107c.865-.818-.696-3.77-3.664-6.909-2.647-2.799-6.26-4.962-7.186-4.201z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.664 42.376c1.85.885 2.381.637 2.415.402l-.303-.503v-.201l-.704-.201-2.314-1.409-5.433-3.621c-.369-.269-.986-.644-.503 0 .603.804 4.527 4.426 6.841 5.533"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M35.384 30.956c-.34.345-.464.842-.395 1.454.07.611.33 1.335.754 2.127.848 1.583 2.344 3.433 4.237 5.202 1.892 1.767 3.877 2.96 5.529 3.57.826.304 1.568.462 2.172.472.605.011 1.069-.125 1.343-.403.778-.785.646-2.04-.155-3.533-.8-1.49-2.257-3.202-4.102-4.881-2.122-1.932-4.122-3.29-5.767-3.985-.823-.348-1.554-.53-2.168-.536-.612-.006-1.103.162-1.449.513z",
    opacity: 0.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    d: "M34.528 29.419c-1.395 1.415.808 5.286 4.597 8.825 3.789 3.54 7.953 4.784 9.087 3.64 1.586-1.601-.567-5.097-4.258-8.458-4.246-3.867-8.014-5.438-9.426-4.007"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M34.55 29.44c-.34.345-.463.841-.394 1.453s.33 1.335.754 2.127c.848 1.583 2.343 3.434 4.236 5.202s3.877 2.96 5.53 3.57c.825.304 1.567.462 2.172.473s1.068-.125 1.343-.403c.777-.785.645-2.04-.156-3.534-.799-1.49-2.257-3.201-4.101-4.88-2.122-1.933-4.122-3.29-5.768-3.986-.822-.347-1.554-.529-2.167-.535s-1.104.162-1.45.512z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.062 29.88c-.995.937 1.103 3.952 4.287 6.927 3.185 2.976 6.59 4.38 7.346 3.57.888-.95-.816-3.88-4-6.857-2.841-2.653-6.68-4.538-7.633-3.64"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M35.985 30.055c-.916.853 1.203 3.798 4.36 6.747 3.156 2.95 6.463 4.412 7.155 3.672.813-.87-.927-3.72-4.083-6.67-2.815-2.63-6.556-4.566-7.433-3.749"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    d: "M38.916 34.044c.499 1.923 4.953 2.015 9.934.577s8.184-4.377 7.783-5.937c-.562-2.182-4.667-2.126-9.445-.68-5.497 1.664-8.777 4.094-8.272 6.04"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5E7A7",
    d: "M38.916 34.044c.499 1.923 4.953 2.015 9.934.577s8.184-4.377 7.783-5.937c-.562-2.182-4.667-2.126-9.445-.68-5.497 1.664-8.777 4.094-8.272 6.04"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M38.916 34.044c.499 1.923 4.953 2.015 9.934.577s8.184-4.377 7.783-5.937c-.562-2.182-4.667-2.126-9.445-.68-5.497 1.664-8.777 4.094-8.272 6.04"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M48.692 40.815a20 20 0 0 1-2.539-1c-2.341-1.109-4.33-2.417-5.618-3.667-.645-.626-1.114-1.235-1.366-1.797s-.285-1.073-.066-1.505c.223-.439.64-.75 1.225-.929q.653-.2 1.561-.185.998.763 2.045 1.715c1.844 1.68 3.302 3.392 4.102 4.881.506.943.744 1.791.656 2.486z",
    opacity: 0.2
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M38.945 34.035c.121.469.485.83 1.045 1.084s1.316.4 2.213.442c1.794.084 4.15-.252 6.638-.97 2.488-.72 4.53-1.812 5.9-2.918.684-.553 1.2-1.11 1.52-1.623.319-.514.439-.98.342-1.36-.276-1.07-1.421-1.6-3.114-1.677-1.688-.078-3.906.297-6.293 1.02-2.747.83-4.937 1.853-6.378 2.909-.72.528-1.25 1.063-1.57 1.586-.32.522-.427 1.03-.303 1.507"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.097 32.963c.294 1.335 3.959 1.08 8.146-.13s7.138-3.414 6.831-4.477c-.361-1.25-3.75-1.29-7.938-.08-3.735 1.078-7.321 3.409-7.039 4.687"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M40.208 33.12c.264 1.223 3.879.913 8.029-.285 4.15-1.199 7.1-3.288 6.82-4.262-.33-1.143-3.67-1.111-7.82.087-3.7 1.07-7.28 3.289-7.029 4.46"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M41.312 32.775c-3.46 0-4.326-1.233-4.326-1.85l1.106.462 1.71.463 6.742-.463 7.342-3.396c-2.707 3.84-8.248 4.784-12.574 4.784z",
    opacity: 0.4
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    d: "M36.46 30.071c.333 1.96 4.761 2.432 9.848 1.426s8.53-3.66 8.263-5.247c-.372-2.223-4.468-2.518-9.352-1.487-5.62 1.186-9.096 3.327-8.76 5.308"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    d: "M36.46 30.071c.333 1.96 4.761 2.432 9.848 1.426s8.53-3.66 8.263-5.247c-.372-2.223-4.468-2.518-9.352-1.487-5.62 1.186-9.096 3.327-8.76 5.308"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M36.46 30.071c.333 1.96 4.761 2.432 9.848 1.426s8.53-3.66 8.263-5.247c-.372-2.223-4.468-2.518-9.352-1.487-5.62 1.186-9.096 3.327-8.76 5.308"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M37.728 29.096c.18 1.355 3.853 1.415 8.128.568 4.275-.846 7.404-2.79 7.189-3.876-.253-1.276-3.627-1.606-7.903-.76-3.813.755-7.586 2.77-7.414 4.068"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M37.826 29.262c.157 1.24 3.786 1.242 8.023.404 4.237-.839 7.357-2.668 7.16-3.662-.23-1.168-3.56-1.422-7.797-.584-3.779.749-7.536 2.652-7.386 3.841z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    d: "M46.528 25.728c4.081 0 7.39-2.865 7.39-6.4 0-3.534-3.309-6.4-7.39-6.4s-7.39 2.866-7.39 6.4 3.31 6.4 7.39 6.4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M46.667 12.82c-1.571-.026-3.176.372-4.506 1.216-1.881 1.186-3.093 3.17-3.013 5.428-.008-2.427 1.578-4.5 3.703-5.55 2.875-1.46 6.672-.993 8.96 1.064 1.287 1.126 2.124 2.749 2.116 4.482.135-3.603-3.01-6.584-7.26-6.64"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M55.45 19.568a6.7 6.7 0 0 0-.118-1.274c-1.138-5.728-7.96-7.826-12.766-5.699l.007-.003c-2.57 1.125-4.475 3.276-4.868 5.97-.315 2.043.337 4.134 1.695 5.703 2.358 2.77 6.369 3.727 9.787 2.785 1.396-.375 2.794-1.12 3.856-2.121 1.47-1.29 2.426-3.356 2.407-5.362m-1.523-.238c-.333 7.19-11.428 8.548-14.293 2.174-.517-1.447-.582-2.997-.079-4.383 2.734-6.651 14.292-5.243 14.372 2.21m1.234 2.227.033-.114z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.093,
    d: "M46.667 12.82c-1.571-.026-3.176.372-4.506 1.216-1.881 1.186-3.093 3.17-3.013 5.428-.008-2.427 1.578-4.5 3.703-5.55 2.875-1.46 6.672-.993 8.96 1.064 1.287 1.126 2.124 2.749 2.116 4.482.135-3.603-3.01-6.584-7.26-6.64z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.093,
    d: "M55.45 19.568a6.7 6.7 0 0 0-.118-1.274c-1.138-5.728-7.96-7.826-12.766-5.699l.007-.003c-2.57 1.125-4.475 3.276-4.868 5.97-.315 2.043.337 4.134 1.695 5.703 2.358 2.77 6.369 3.727 9.787 2.785 1.396-.375 2.794-1.12 3.856-2.121 1.47-1.29 2.426-3.356 2.407-5.362zm-1.523-.238c-.333 7.19-11.428 8.548-14.293 2.174-.517-1.447-.582-2.997-.079-4.383 2.734-6.651 14.292-5.243 14.372 2.21zm1.234 2.227.033-.114z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M46.667 12.82c-1.571-.026-3.176.372-4.506 1.216-1.881 1.186-3.093 3.17-3.013 5.428-.008-2.427 1.578-4.5 3.703-5.55 2.875-1.46 6.672-.993 8.96 1.064 1.287 1.126 2.124 2.749 2.116 4.482.135-3.603-3.01-6.584-7.26-6.64z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M55.45 19.568a6.7 6.7 0 0 0-.118-1.274c-1.138-5.728-7.96-7.826-12.766-5.699l.007-.003c-2.57 1.125-4.475 3.276-4.868 5.97-.315 2.043.337 4.134 1.695 5.703 2.358 2.77 6.369 3.727 9.787 2.785 1.396-.375 2.794-1.12 3.856-2.121 1.47-1.29 2.426-3.356 2.407-5.362zm-1.523-.238c-.333 7.19-11.428 8.548-14.293 2.174-.517-1.447-.582-2.997-.079-4.383 2.734-6.651 14.292-5.243 14.372 2.21zm1.234 2.227.033-.114z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#6585A5",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m62.74 32.361 5.084.774-3.717.09z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    d: "m62.74 32.361 5.084.774-3.717.09z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m62.74 32.361 5.084.774-3.717.09z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F6780",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m64.107 33.226-.037.313-1.367-.864.036-.314z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    d: "m64.107 33.226-.037.313-1.367-.864.036-.314z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m64.107 33.226-.037.313-1.367-.864.036-.314z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#6585A5",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m58.94 32.454 5.084.773-3.717.09z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    d: "m58.94 32.454 5.084.773-3.717.09z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m58.94 32.454 5.084.773-3.717.09z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F6780",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m60.307 33.318-.036.314-1.367-.865.036-.313z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    d: "m60.307 33.318-.036.314-1.367-.865.036-.313z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m60.307 33.318-.036.314-1.367-.865.036-.313z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#6585A5",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m55.14 32.545 5.084.774-3.717.09z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    d: "m55.14 32.545 5.084.774-3.717.09z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m55.14 32.545 5.084.774-3.717.09z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F6780",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m56.507 33.41-.036.313-1.367-.864.036-.314z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    d: "m56.507 33.41-.036.313-1.367-.864.036-.314z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m56.507 33.41-.036.313-1.367-.864.036-.314z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#6585A5",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m51.341 32.639 5.083.773-3.716.09z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    d: "m51.341 32.639 5.083.773-3.716.09z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m51.341 32.639 5.083.773-3.716.09z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F6780",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m52.708 33.502-.037.314-1.367-.864.037-.313z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    d: "m52.708 33.502-.037.314-1.367-.864.037-.313z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m52.708 33.502-.037.314-1.367-.864.037-.313z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#6585A5",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m47.541 32.731 5.084.774-3.718.09z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    d: "m47.541 32.731 5.084.774-3.718.09z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m47.541 32.731 5.084.774-3.718.09z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F6780",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m48.907 33.595-.036.314-1.367-.864.037-.314z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    d: "m48.907 33.595-.036.314-1.367-.864.037-.314z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m48.907 33.595-.036.314-1.367-.864.037-.314z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#828990",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m35.285 82.419 18.69-.574 2.223.037-18.69.575z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m63.096 83.053.01-.044q.054-.191.097-.387l-18.69.574q-.045.196-.097.387l-.027.098q-.061.217-.133.427l-.006.018q-.076.219-.164.432l-.036.086q-.09.213-.191.418l-.035.069q-.114.224-.239.439l-.013.02q-.15.252-.313.488l-.019.026a9 9 0 0 1-.173.236q-.033.044-.068.086l-.134.167-.066.076q-.097.114-.198.222-.034.038-.068.073-.128.137-.263.264l-.082.076-.143.13-.096.08-.138.116-.104.08-.138.105-.11.079-.139.096-.115.075a7 7 0 0 1-.524.306l-.146.075a8 8 0 0 1-.274.129l-.128.055-.152.061-.13.05a5 5 0 0 1-.286.098q-.08.025-.16.048-.066.02-.131.037-.082.022-.165.04l-.13.032q-.087.019-.172.034l-.128.025q-.09.014-.183.027l-.12.018-.206.02-.101.011a7 7 0 0 1-.31.017l18.69-.574q.157-.005.31-.017.051-.004.101-.01.105-.01.206-.021l.12-.018q.093-.013.183-.027.065-.011.128-.025.087-.015.172-.034l.13-.031a7 7 0 0 0 .297-.078q.08-.023.16-.048l.13-.043q.08-.026.157-.056.065-.023.13-.049.075-.03.152-.062l.127-.055a8 8 0 0 0 .543-.27q.072-.038.143-.081.06-.035.118-.07l.141-.09q.057-.035.115-.074.07-.047.139-.096l.11-.079.138-.105q.052-.04.103-.08l.139-.116.096-.08.145-.132q.037-.033.073-.067l.27-.272q.035-.035.069-.072a8 8 0 0 0 .198-.222l.041-.047.024-.03q.069-.082.134-.166l.069-.087q.087-.116.173-.236l.018-.025.001-.002q.025-.035.048-.072.06-.088.12-.179.03-.049.061-.099.048-.075.093-.151l.004-.007q.126-.214.239-.439l.022-.04.012-.028q.102-.204.192-.418l.017-.036.018-.05q.088-.211.165-.43v-.004l.006-.015q.07-.21.132-.426l.016-.054z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m54.414 38.27-9.901 44.927 18.69-.575 9.901-44.927z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m40.889 42.225-4.59-.508-5.975-.006-.113-.024c-1.851-.392-4.924-1.037-5.226-1.084l.95-.63c.422.064 4.224.873 5.243 1.09l5.885.006 4.523.503 6.414-.34-.457.64z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M29.375 82.048 25.21 40.319c.302.046 3.375.69 5.226 1.084l2.006 41.029c-1.088-.14-2.89-.368-3.067-.385"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "3-wallet_svg__b",
    width: 8,
    height: 43,
    x: 25,
    y: 40,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.375 82.048 25.21 40.319c.302.046 3.375.69 5.226 1.084l2.006 41.029c-1.088-.14-2.89-.368-3.067-.385"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#4C4C4C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    mask: "url(#3-wallet_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.375 82.048 25.21 40.319l.124.023 4.114 41.713z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.448 82.056-4.114-41.714c.664.126 3.4.7 5.102 1.062l2.006 41.028a464 464 0 0 0-2.994-.376"
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M29.375 82.048 25.21 40.319c.302.046 3.375.69 5.226 1.084l2.006 41.029c-1.088-.14-2.89-.368-3.067-.385"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M36.64 83.706c-.49.032-2.414.043-4.206-1.548l-1.976-40.761 5.976.004z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m41.023 41.91-1.166 40.593c-.792.736-1.79 1.192-3.097 1.192q0 .002-.12.011l-.205-42.305z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m47.678 41.56-2.533 32.786-1.456-.1c-1.103 2.595-1.785 6.359-3.833 8.257l1.167-40.592z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.079 41.931s2.623 1.606 2.59 8.702c-.036 8.257-2.738 22.216-2.855 22.811l5.976-31.571-5.712.058",
    opacity: 0.2
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6BB70",
    d: "m45.145 74.347 2.534-32.787.456-.642-2.684 33.45"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m45.145 74.347 2.534-32.787.456-.642-2.684 33.45"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M73.179 36.85q-.002-.059-.005-.117l-.001-.035a3 3 0 0 0-.026-.218l-.008-.047-.014-.09-.034-.152-.007-.032a4 4 0 0 0-.075-.251l-.021-.062a3 3 0 0 0-.086-.216l-.013-.031a3 3 0 0 0-.116-.231l-.032-.055a3 3 0 0 0-.122-.194l-.02-.03a3 3 0 0 0-.123-.166l-.022-.024a3 3 0 0 0-.162-.18q-.022-.026-.043-.049l-.01-.008q-.035-.035-.073-.068-.056-.054-.117-.106l-.019-.014-.06-.046q-.053-.041-.106-.081-.025-.017-.052-.033l-.065-.042q-.03-.02-.062-.04l-.125-.069-.038-.02-.014-.008a3 3 0 0 0-.179-.081l-.042-.016-.057-.022q-.041-.016-.084-.03a2 2 0 0 0-.163-.05l-3.214-.85-18.69.574 3.213.85q.127.035.247.08l.058.022q.12.047.234.104l.037.021a3 3 0 0 1 .41.265l.06.046q.07.058.136.12l.074.067q.026.028.052.057a3 3 0 0 1 .308.37l.02.03q.063.094.121.193l.032.056q.062.112.116.23l.013.031a3 3 0 0 1 .108.278q.041.124.074.252l.007.032q.03.12.049.241l.008.048q.017.126.027.253.003.057.005.116.004.09.002.182 0 .047-.003.095a4 4 0 0 1-.016.207q-.003.037-.008.074a4 4 0 0 1-.05.287l18.691-.574.008-.034a3 3 0 0 0 .037-.213l.004-.04.008-.074q.008-.056.012-.113.003-.045.004-.094l.003-.094q.002-.03.003-.057-.002-.063-.005-.126z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m44.251 35.62 4.762-1.864-1.19 5.473zM49.013 33.756l.337.133-1.189 5.473-.337-.133zM43.048 41.152l4.761-1.863-1.188 5.473z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m47.81 39.29.337.132-1.189 5.473-.337-.133zM41.846 46.688l4.761-1.865-1.189 5.473zM46.607 44.823l.338.133-1.189 5.473-.337-.133zM40.643 52.222l4.762-1.864-1.19 5.474zM45.405 50.359l.337.133-1.19 5.473-.336-.133zM39.44 57.755l4.762-1.864-1.189 5.474z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m44.202 55.892.337.133-1.189 5.473-.337-.133zM38.237 63.29 43 61.426 41.81 66.9zM43 61.427l.338.133-1.19 5.473-.338-.133zM37.035 68.823l4.762-1.863-1.19 5.473zM41.798 66.96l.337.133-1.19 5.473-.338-.133zM35.832 74.357l4.763-1.864-1.19 5.473zM40.595 72.493l.338.134-1.19 5.472-.338-.133zM29.413 36.028l-3.54 4.055-1.166-5.908zM30.592 42.002l-3.54 4.055-1.167-5.909zM31.77 47.976l-3.54 4.054-1.166-5.907zM32.948 53.95l-3.54 4.054-1.166-5.907zM34.128 59.924l-3.541 4.054-1.165-5.908zM35.307 65.897l-3.542 4.054-1.165-5.908zM36.484 71.87l-3.541 4.055-1.165-5.908zM37.663 77.845l-3.542 4.054-1.165-5.908z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1C",
    d: "M36.725 75.255c-.758-.01-1.763-.128-2.322-.112-.649.019-1.371.562-1.883.87.576-.512 3.43-.111 4.139-.18.813.016 1.566.611 1.778 1.395.162.258-.188 3.96-.18 4.326a.85.85 0 0 1-.38.655c.31-.245 1.196-.629 1.28-1.064.062-.198.062-3.091.066-3.303"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M36.725 75.255c-.758-.01-1.763-.128-2.322-.112-.649.019-1.371.562-1.883.87.576-.512 3.43-.111 4.139-.18.813.016 1.566.611 1.778 1.395.162.258-.188 3.96-.18 4.326a.85.85 0 0 1-.38.655c.31-.245 1.196-.629 1.28-1.064.062-.198.062-3.091.066-3.303"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "m24.658 34.119 8.456 41.507-.641.573.697-.168 1.123 5.51c.103.51.51.87.992.877l2.223.038c.48.007.893-.342 1.005-.848l10.566-47.947 3.214.85c1.54.408 2.488 2.09 2.121 3.757l-9.901 44.927c-.778 3.531-3.702 6-7.051 5.954l-2.233-.037c-3.37-.051-6.233-2.585-6.96-6.16l-9.195-45.256c-.34-1.677.634-3.33 2.18-3.692l3.227-.756"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m24.658 34.119 8.456 41.507-.641.573.697-.168 1.123 5.51c.103.51.51.87.992.877l2.223.038c.48.007.893-.342 1.005-.848l10.566-47.947 3.214.85c1.54.408 2.488 2.09 2.121 3.757l-9.901 44.927c-.778 3.531-3.702 6-7.051 5.954l-2.233-.037c-3.37-.051-6.233-2.585-6.96-6.16l-9.195-45.256c-.34-1.677.634-3.33 2.18-3.692l3.227-.756"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m37.484 87.556-2.228-.038c-2.619-.04-4.848-2.048-5.425-4.884l-9.195-45.256c-.168-.825.282-1.659.981-1.823l1.629-.381 9.484 46.685c.255 1.25 1.296 2.136 2.532 2.153l2.259.038c1.227 0 2.274-.862 2.548-2.097l10.208-46.326 1.608.426c.71.187 1.155 1.045.973 1.873l-9.902 44.927c-.61 2.77-2.831 4.704-5.402 4.704h-.071z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m46.56 73.906-2.047 9.29c-.777 3.532-3.702 6-7.052 5.954l-2.231-.038c-3.37-.051-6.233-2.584-6.96-6.16l-5.462-26.887c5.712 1.358 4.028 7.233 6.08 12.511.86 2.213 3.208 4.117 4.08 6.34l.145.711-.64.573.698-.169.128.625c-.039 1.644-1.124 3.39-1.124 4.972s1.435 3.02 3.42 3.02c7.57 0 6.162-10.821 10.387-10.821q.288 0 .578.078z",
    opacity: 0.2
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m36.861 75.856-3.192-.08c-1.041-.026-1.8.845-1.625 1.863l.657 3.793c.08.468.502.83.98.843l3.888.098c.478.012.86-.33.89-.796l.238-3.77c.064-1.012-.794-1.924-1.836-1.95"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.639 81.81c0 .22-.1.395-.262.533l-2.695-.068c-.48-.012-.9-.374-.982-.844l-.657-3.791c-.175-1.019.583-1.89 1.626-1.865l1.143.029q.128.122.129.298c0 .691-1.379 1.839-1.379 2.864 0 1.206 3.076 1.7 3.076 2.843",
    opacity: 0.2
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M35.735 81.62q0 .06-.006.114l-.002.007a1 1 0 0 1-.018.1q0 .006-.003.01a1 1 0 0 1-.029.092l-.004.011a1 1 0 0 1-.038.082l-.01.018-.037.057-.019.027-.02.025a1 1 0 0 1-.07.072l-.025.023a1 1 0 0 1-.102.072l.47-.27a1 1 0 0 0 .102-.073q.014-.01.027-.023a1 1 0 0 0 .067-.072l.015-.014.007-.01.019-.027.023-.034.014-.024.01-.018.009-.016.024-.053.005-.013.005-.011q.004-.013.01-.025l.014-.05.004-.016.003-.011.005-.02a1 1 0 0 0 .013-.08v-.008l.002-.007.004-.048q.003-.025.002-.05v-.007zM36.203 79.377l-.47.271.002 1.972.471-.27z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M35.732 79.648c0-.5-.38-.95-.851-1.008-.47-.058-.85.3-.85.8l.003 1.972c0 .499.383.95.852 1.008.47.058.85-.3.85-.8z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m35.048 78.677.01.004q.038.014.075.03h.003l.066.035.017.009a1 1 0 0 1 .32.296 1.1 1.1 0 0 1 .154.32l.001.005q.011.04.02.08l.003.019.011.08v.004a1 1 0 0 1 .005.09l.47-.272v-.043l-.004-.047v-.005l-.007-.054-.004-.024-.004-.019-.003-.015-.016-.064-.001-.005-.022-.07-.003-.006-.037-.09q0 0 0 0a1 1 0 0 0-.091-.155v-.001a1 1 0 0 0-.115-.135v-.001a1 1 0 0 0-.073-.066l-.005-.004-.06-.046q0 0 0 0l-.055-.035-.012-.007-.016-.009a1 1 0 0 0-.069-.035h-.001l-.047-.02-.027-.009-.01-.003-.008-.003-.045-.014-.02-.004-.013-.003-.013-.003-.047-.009-.022-.003-.026-.003-.048-.003h-.054q-.026 0-.048.003l-.057.008-.01.002-.013.004q-.021.003-.042.01-.023.007-.05.016l-.02.006q-.003.002-.008.003a1 1 0 0 0-.09.045l-.471.271a1 1 0 0 1 .1-.047l.02-.007a.8.8 0 0 1 .218-.042h.002a.8.8 0 0 1 .208.02l.012.003.074.02z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m23.36 35.722-.439-2.092"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "M36.727 82.79c.001-.036.005-.07.002-.106v-.01q-.004-.019-.006-.038-.004-.05-.012-.097-.004-.017-.009-.035l-.011-.044q-.005-.024-.012-.047a1 1 0 0 0-.04-.101l-.505-1.126a1 1 0 0 1 .051.149l.012.044q.015.065.02.132l.005.038c.003.038 0 .077 0 .116-.002.025 0 .05-.003.075a1.4 1.4 0 0 1-.033.195l.505 1.125q.024-.096.034-.188v-.006q.002-.038.002-.076zM33.744 86.38c-.127-.282-.418-.488-.813-.53a1 1 0 0 0-.133-.007l-.044.001q-.045 0-.09.004h-.01q-.015.002-.028.003-.06.006-.12.018l-.024.003-.027.007-.078.019-.035.008-.021.008-.063.02-.04.014-.02.008-.056.023q-.02.007-.04.017l-.021.01-.053.027-.037.018-.022.013-.053.031-.032.02-.022.014-.055.038-.03.021q-.01.007-.018.014l-.066.053-.028.024-.01.009q-.056.052-.106.106l-.004.004-.015.018-.07.087-.026.038-.051.081-.015.024-.009.017a1 1 0 0 0-.04.087q-.008.014-.013.027l-.007.018a1 1 0 0 0-.035.112l-.007.032a1 1 0 0 0-.015.086l-.003.018v.007a1 1 0 0 0-.003.12v.012l.002.017.01.076q0 .009.002.018l.003.01a1 1 0 0 0 .02.08l.002.008v.001a1 1 0 0 0 .03.077l.506 1.125-.03-.076-.002-.01a1 1 0 0 1-.021-.08l-.005-.028-.01-.076-.002-.028q-.002-.06.003-.12l.004-.026a1 1 0 0 1 .015-.086l.007-.031q.014-.056.035-.112l.02-.045q.018-.045.04-.087l.024-.042q.023-.04.05-.08l.027-.038a1 1 0 0 1 .07-.088l.018-.022q.051-.055.107-.106l.038-.033.065-.053a1.4 1.4 0 0 1 .158-.108 2 2 0 0 1 .164-.088q.03-.014.061-.027l.056-.024.06-.021.064-.021.055-.016a1 1 0 0 1 .13-.029q.059-.01.119-.017.018-.003.038-.004.045-.004.09-.004l.044-.001q.067 0 .132.007c.396.041.686.248.814.53z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m36.186 81.935-1.05 4.986.505 1.124 1.05-4.986zM35.537 88.39l.022-.066q.012-.03.02-.06.038-.108.062-.219l-.506-1.125a2 2 0 0 1-.06.22l-.021.059a2 2 0 0 1-.077.19l-.01.022a3 3 0 0 1-.21.361l-.05.075a3 3 0 0 1-.364.414l-.041.039-.116.1q-.061.052-.125.102-.096.076-.2.145a4 4 0 0 1-.255.153l-.004.002q-.12.065-.244.12l-.088.036a3 3 0 0 1-.169.066q-.057.02-.115.039a4 4 0 0 1-.3.081q-.078.019-.156.033l-.056.01a4 4 0 0 1-.246.03q-.096.008-.19.009l-.096.003q-.143 0-.282-.015c-.759-.08-1.352-.435-1.646-.985a2 2 0 0 1-.059-.117l.506 1.125q.027.06.059.118c.293.55.886.905 1.646.985q.14.014.281.015.049-.001.096-.004.096-.001.19-.008h.01a4 4 0 0 0 .292-.04l.065-.01.09-.023q.076-.016.15-.036l.05-.012.1-.033.116-.039q.02-.006.041-.014.064-.025.128-.052.045-.019.087-.037l.023-.01a4 4 0 0 0 .222-.11l.004-.003q.112-.06.22-.129l.035-.022q.084-.056.162-.115l.038-.03q.064-.05.125-.103l.074-.061q.021-.02.041-.04l.041-.038q.092-.087.174-.177l.002-.002q.1-.115.188-.234.026-.037.05-.076.059-.084.11-.17.009-.015.019-.032.044-.079.082-.16l.009-.021q.03-.063.054-.126z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.157,
    d: "m35.77 80.745-.13.346c-.155.41-.68.714-1.147.665-.482-.05-.735-.424-.575-.846l.12-.32c-.554.182-1.01.546-1.272.997l-2.654 4.817c-.358.627-.395 1.29-.098 1.826.293.55.886.905 1.646.985.73.077 1.536-.132 2.201-.568.67-.448 1.13-1.065 1.275-1.728l1.05-4.986c.12-.479-.037-.91-.416-1.188m-2.02 6.308c-.208.59-.945 1.018-1.63.946-.672-.07-1.042-.615-.82-1.203s.96-1.017 1.631-.946c.67.07 1.041.615.82 1.203"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m72.586 40.05-9.383 42.572q-.044.196-.095.388-.007.02-.011.044l-.018.053a6 6 0 0 1-.132.425l-.003.016-.002.003q-.077.22-.166.432l-.017.05q-.01.017-.017.036-.091.214-.192.417l-.012.027q-.01.021-.023.042-.112.225-.239.44l-.003.006-.092.151q-.03.049-.061.1l-.121.178q-.024.038-.048.072-.001.002-.002.003l-.017.024a6 6 0 0 1-.243.323 4 4 0 0 1-.133.166l-.024.03q-.02.023-.042.046-.095.115-.198.223l-.067.072a7 7 0 0 1-.271.272l-.075.068q-.07.065-.143.13l-.096.08-.138.117-.104.08a4 4 0 0 1-.248.182l-.139.097q-.057.038-.115.075a5 5 0 0 1-.26.158 3 3 0 0 1-.143.083l-.12.065a6 6 0 0 1-.271.136q-.075.036-.15.068-.063.03-.128.054-.074.032-.153.063l-.128.049-.158.054q-.064.022-.128.043l-.161.05c-.043.01-.088.025-.131.036l-.166.041q-.063.016-.13.03l-.17.035-.129.024q-.09.016-.183.027-.06.01-.121.017-.102.014-.206.021-.05.005-.1.012a8 8 0 0 1-.31.016l-18.69.575q.156-.006.31-.017l.1-.01q.103-.008.206-.022l.122-.016q.09-.014.181-.029.065-.011.128-.024.087-.016.172-.035l.131-.03q.084-.019.164-.041l.133-.037.16-.048.13-.044q.08-.025.156-.054.064-.024.13-.05l.152-.06q.064-.028.128-.056.075-.033.148-.068l.126-.06q.074-.037.145-.076a4 4 0 0 0 .267-.147q.06-.035.118-.07l.142-.09q.058-.036.114-.074l.139-.096.11-.08.137-.103.104-.082q.072-.055.139-.114l.097-.082.142-.129q.043-.037.083-.076a8 8 0 0 0 .33-.337q.101-.108.198-.223l.065-.076q.07-.082.134-.166l.069-.087q.087-.116.173-.236l.018-.025q.165-.236.314-.488l.012-.021a9 9 0 0 0 .274-.507q.101-.206.192-.42l.035-.085q.087-.213.164-.432.005-.008.006-.017.071-.21.133-.427.016-.047.027-.098.053-.19.097-.387l2.172-9.854a15 15 0 0 1 1.223-1.56c3.641-4.045 9.16-5.073 13.093-8.616 8.942-8.058 1.853-23.152 10.902-23.152q.329 0 .682.036zM30.59 41.512s2.655 4.406 4.02 11.715c1.588 8.505 1.92 20.132 1.92 20.745l-.24-32.52z",
    opacity: 0.2
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.315,
    d: "m73.28 33.703 7.091-6.291m-8.268 5.268.888-4.65m1.407 7.282 2.909-.562"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2EEFF",
    d: "m14.292 37.59-.03-.155-.011.307zm1.83-4.782.045-.15a.157.157 0 0 0-.168.25zm1.317 10.526.157.018c.092-.811.041-2.075-.41-3.243-.455-1.172-1.318-2.258-2.853-2.672l-.041.153-.041.152c1.413.38 2.212 1.375 2.64 2.48.43 1.11.48 2.322.392 3.094zm-3.147-5.745.03.155c.837-.165 1.963-.61 2.56-1.432.302-.417.467-.93.388-1.538-.078-.604-.395-1.29-1.027-2.065l-.122.1-.122.099c.61.747.89 1.38.959 1.907a1.77 1.77 0 0 1-.331 1.311c-.528.727-1.558 1.15-2.366 1.309zm1.83-4.78-.047.15c.559.172 1.44.308 2.27.153.838-.157 1.64-.615 1.987-1.64l-.15-.05-.149-.05c-.3.886-.985 1.288-1.745 1.43-.768.144-1.595.017-2.12-.144z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F2EEFF",
    strokeLinecap: "round",
    strokeWidth: 0.315,
    d: "M58.61 18.345c-.045-2.294-1.585-6.27-6.377-9.04m4.452 9.157c-.17-2.158-1.426-5.288-4.926-6.997"
  })));
};
export default Svg3Wallet;